
import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountingService } from 'src/app/services/accounting/accounting.service';
import * as moment  from 'moment';

@Component({
  selector: 'app-acc-setting',
  templateUrl: './acc-setting.component.html',
  styleUrls: ['./acc-setting.component.css']
})
export class AccSettingComponent implements OnInit {

  constructor(private accService:AccountingService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) { }

  BankAccountModel = {
    BankID: 0,
    BankName: '',
    BankAddress: '',
    Remark: '',
    IsActive: true
   
};
Submitted = false;
loading = false;
Clear () {
    this.BankAccountModel.IsActive = false;
    this.BankAccountModel.Remark = '';
    this.BankAccountModel.BankID = 0;
    this.BankAccountModel.BankName = '';
    this.BankAccountModel.BankAddress = '';
    this.Submitted = false;
    this.loading = false;

};      


SaveBank (valid) {
    this.Submitted = true;
       if (valid) {
        this.loading = true;
        this.accService.SaveBank(JSON.stringify(this.BankAccountModel)).subscribe( (response)=> {
            setTimeout( () =>{
                this.loading = false;
            }, 10);
             this.globalHelper.CheckActionStatus(response);

            if (response.webResponse.Status) {
                this.Clear();
                this.GetAllBank();
            }

        });
    }
};
BankList:any;
GetAllBank () {
    
    this.accService.GetAllBank().subscribe( (response)=> {
        this.BankList = response.ListBankDetails;
        
    });
};

MarkBankActive (item) {
    item.loading = true;
    this.Clear();
    this.BankAccountModel.BankID = item.BankID;
    this.BankAccountModel.IsActive=item.IsActive == true ? false : true;
  
    this.accService.MarkBankActive(JSON.stringify(this.BankAccountModel)).subscribe( (response)=> {
        item.loading = false;
         this.globalHelper.CheckActionStatus(response);
        this.GetAllBank();
    });
};

Edit (obj) {
   
    this.BankAccountModel.IsActive = obj.IsActive;
    this.BankAccountModel.Remark = obj.Remark;
    this.BankAccountModel.BankID = obj.BankID;
    this.BankAccountModel.BankName = obj.BankName;
    this.BankAccountModel.BankAddress = obj.BankAddress;

};

  ngOnInit() {
    this.GetAllBank();
  }

}
